<section class="section-parametre" [ngBusy]="{
    busy: busyGet,
    message: 'Veuillez patienter ...',
    backdrop: false
  }">
      <div class="">
          <div class="row clearfix">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <div class="card">
                      <div class="body table-responsive">
                          <table class="table table-stripped table-bordered table-hover">
                              <thead>
                                  <tr>
                                      <th colspan="12">
                                          <div class="row mt-1">
                                              <div class="col-md-5">
                                                  <input [(ngModel)]="searchKey"
                                                      class="form-control custom-input pull-left"
                                                      placeholder="Rechercher ..."
                                                      (keyup)="currentPage = 0; getItems()" />
                                              </div>
  
                                              <div class="col-md-7">
                                                  <!-- <button type="button" class="btn btn-md custom_btn_primary pull-right"
                                                      (click)="openModal(null, templateCrud)">
                                                      <i class="fa fa-plus"></i>&nbsp; Ajouter
                                                  </button> -->
                                              </div>
                                          </div>
                                      </th>
                                  </tr>
                                  <tr class="custom-table-head">
                                      <th>
                                          <a style="cursor: pointer" (click)="currentPage = 0; getItems()"
                                              title="Actualiser">
                                              <i class="fa fa-redo-alt"></i></a>&nbsp;&nbsp; #
                                      </th>
                                      <!-- <th>Notification</th> -->
                                      <th>Ordre</th>
                                      <th>Validateur</th>
                                      <th>Statut</th>
                                      <th>Role validateur</th>
                                      <th>Commentaire</th>
                                      <th>Crée par</th>
                                   
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr *ngFor="let item of items; let indice = index">
                                      <td class="txt-align-center">{{ currentPage>1?(((currentPage - 1) * this.itemsPerPage) + (indice+1)):indice+1 }}</td>
                                      <!-- <td>{{ item?.code}}</td> -->
                                      <!-- <td>{{ item?.notification_libelle}}</td> -->
                                      <td>{{ item?.ordre}}</td>
                                      <td>{{ item?.user_nom}} {{ item?.user_prenom}}</td>
                                      <td>{{ item?.statut}}</td>
                                      <td>{{ item?.role_libelle}}</td>
                                      <td>{{ item?.commentaire}}</td>
                                      <td>{{ item?.created_by_login}}</td>
                                  </tr>
                              </tbody>
  
                              <tfoot>
                                  <tr *ngIf="items && items.length > 0">
                                      <td colspan="12">
                                          <div class="row pagination-part">
                                              <div class="col-md-9" style="text-align: center">
                                                  <pagination [maxSize]="5" [boundaryLinks]="true"
                                                      [itemsPerPage]="itemsPerPage" [totalItems]="totalItems"
                                                      [(ngModel)]="currentPage" class="pagination-sm"
                                                      previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
                                                      lastText="&raquo;" (pageChanged)="pageChanged($event)">
                                                  </pagination>
                                              </div>
  
                                              <div class="col-md-3">
                                                  <div class="paginator-per-page">
                                                      <app-element-by-page-paginator (paginationChange)="
                              changePaginationSize($event)
                            " [defaultItemPerPage]="itemsPerPage">
                                                      </app-element-by-page-paginator>
  
                                                      <span class="span_total_entree pull-right">Total : {{ totalItems
                                                          }}</span>
                                                  </div>
                                              </div>
                                          </div>
                                      </td>
                                  </tr>
  
                                  <tr *ngIf="!items || items.length == 0">
                                      <td colspan="12">
                                          <div class="col-md-12 txt-align-center">
                                              Aucune donnée disponible
                                          </div>
                                      </td>
                                  </tr>
                              </tfoot>
                          </table>
                      </div>
                  </div>
  
                  
  
              </div>
          </div>
      </div>
  </section>
  
  
  
  